import { useTranslation } from 'react-i18next';

import AudioToggleButton from '@/shared/components/audioToggle/AudioToggleButton';
import BackButton from '@/shared/components/button/BackButton';

import '@/features/timeGame/styles/control-bar.scss';

interface ControlBarProps {
	onBack: () => void;
	isAudioTooltipOpen?: boolean;
	small?: boolean;
}

const ControlBar = ({ onBack, isAudioTooltipOpen = false, small = false }: ControlBarProps) => {
	const { t } = useTranslation();

	return (
		<div className="time-game-control-bar">
			<div className="container">
				<BackButton onClick={onBack} small={small} />
				<AudioToggleButton
					tooltip={t('time_game.audio_toggle.tooltip')}
					isOpen={isAudioTooltipOpen}
					small={small}
				/>
			</div>
		</div>
	);
};

export default ControlBar;
